import { render, staticRenderFns } from "./MembershipMatchesList.vue?vue&type=template&id=34f46c36&scoped=true"
import script from "./MembershipMatchesList.vue?vue&type=script&lang=js"
export * from "./MembershipMatchesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f46c36",
  null
  
)

export default component.exports